<template>
  <base-dropdown
    ref="baseDropdown"
    margin-top="6"
    placement="bottom-start"
    width="440"
    @show="show"
  >
    <div class="dropdown-menu">
      <ul class="menu-list">
        <li v-if="dataRange.includes('user')" @click="handleSelect('open-user-dialog')">
          <span class="icon-container icon-user"><i class="el-icon-user-solid"></i></span>
          <span>{{ displayText.addUser }}</span>
        </li>
        <li v-if="dataRange.includes('role')" @click="handleSelect('open-role-dialog')">
          <span class="icon-container icon-role"><i class="el-icon-user-solid"></i></span>
          <span>{{ displayText.addRole }}</span>
        </li>
        <li v-if="dataRange.includes('mail')" @click="handleSelect('open-mail-dialog')">
          <span class="icon-container icon-role"><i class="el-icon-message"></i></span>
          <span>{{ displayText.addMail }}</span>
        </li>
      </ul>
      <div class="tip-workflow-people">
        <span class="icon-container"><i class="el-icon-s-operation"></i></span>
        <span>使用工作流变量里的人员{{ dataRange.includes("mail") ? "、邮箱" : "" }}</span>
      </div>
      <el-collapse v-model="activeName" accordion>
        <el-collapse-item
          v-for="(group, index) in peopleVariables"
          :key="index"
          :name="group.label"
        >
          <template slot="title">
            <span class="icon-container"><i class="el-icon-s-grid"></i></span>
            {{ group.label }}
          </template>
          <ul v-ps style="max-height: 200px;">
            <li
              v-for="(item, index) in group.options"
              :key="index"
              @click="handleSelect('select-variable', item)"
            >
              {{ item.label }}
            </li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
    <template v-slot:reference>
      <div class="add-btn">
        <span class="icon-add"><i class="el-icon-plus"></i></span>
        {{ displayText.addBtn }}
      </div>
    </template>
  </base-dropdown>
</template>

<script>
import BaseDropdown from "@/components/UIComponents/Dropdown"

export default {
  name: "dropdown-menu",
  components: {
    BaseDropdown
  },
  props: {
    displayText: Object,
    peopleVariables: Array,
    dataRange: Array
  },
  data() {
    return {
      activeName: ""
    }
  },
  methods: {
    handleSelect(command, value) {
      this.$emit("command", command, value)
      this.$refs.baseDropdown.close()
    },
    show() {
      this.activeName = this.peopleVariables?.[0]?.label
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-menu {
  user-select: none;
  margin: 5px 0;
  color: #333;
  .menu-list {
    li {
      height: 36px;
      line-height: 36px;
      cursor: pointer;
      vertical-align: middle;
      box-sizing: border-box;
      width: 100%;
      padding: 0 16px;
      &:hover {
        background-color: $color-main;
        color: #fff;
        .icon-user,
        .icon-role {
          color: $color-main;
          background-color: #fff;
        }
      }
      .icon-user,
      .icon-role {
        color: #fff;
        background-color: #9e9e9e;
      }
      .icon-role {
        border-radius: 50%;
      }
    }
  }
  .tip-workflow-people {
    height: 36px;
    line-height: 36px;
    padding: 0 16px;
    color: #9e9e9e;
    border-top: 1px solid #ddd;
    box-sizing: border-box;
    .icon-container {
      vertical-align: middle;
      font-size: 18px;
    }
  }
  .icon-container {
    display: inline-block;
    margin-right: 8px;
    width: 18px;
    height: 18px;
    line-height: 18px;
    text-align: center;
  }
  .el-collapse {
    border: none;
    ::v-deep {
      .el-collapse-item__header {
        padding: 0 16px;
        height: 36px;
        line-height: 36px;
        border: none;
        .icon-container {
          font-size: 18px;
          color: #9e9e9e;
        }
      }
      .el-collapse-item__content {
        padding-bottom: 0;
        background-color: #f5f5f5;
        ul {
          li {
            height: 36px;
            line-height: 36px;
            padding: 0 16px 0 40px;
            cursor: pointer;
            &:hover {
              color: #fff;
              background-color: $color-main;
            }
          }
        }
      }
    }
  }
}
.add-btn {
  display: inline-block;
  color: #bdbdbd;
  cursor: pointer;
  &:hover {
    color: $color-main;
  }
  .icon-add {
    display: inline-block;
    margin-right: 4px;
    text-align: center;
    line-height: 28px;
    border-radius: 50%;
    border: 1px dashed currentColor;
    width: 28px;
    height: 28px;
    box-sizing: border-box;
    flex-basis: 0;
  }
}
</style>
